export default __webpack_public_path__ + "static/media/grass_medium_texture.4d905c38.jpg";